<template>
  <v-select
    :items="sucursalesConTodas"
    :label="label"
    :multiple="multiple"
    hide-details
    clearable
    :prepend-icon="icono"
    item-text="nombre"
    item-value="id"
    return-object
    v-model="internalSelected"
    @change="emitSelection"
  >
    <!-- Chips cuando es multiple -->
    <template v-if="multiple" v-slot:selection="data">
      <v-chip
        v-if="data.item && data.item.nombre !== 'Todas las sucursales'"
        small
        class="ma-1"
        color="primary"
        text-color="white"
      >
        {{ data.item.nombre }}
        {{ multiple }}
      </v-chip>
      <span v-else>Todas las sucursales</span>
    </template>
  </v-select>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "SucursalesVSelect",
  props: {
    multiple: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: "Sucursales",
    },
    icono: {
      type: String,
      default: "mdi-home-group",
    },
  },
  data() {
    return {
      internalSelected: this.multiple ? [] : null,
    };
  },
  computed: {
    ...mapState("sucursales", ["sucursales"]),
    sucursalesConTodas() {
      return [
        { id: 0, uuid: "all", nombre: "Todas las sucursales" },
        ...this.sucursales,
      ];
    },
  },
  methods: {
    ...mapActions("sucursales", ["fetch_sucursales"]),
    emitSelection() {
      if (this.multiple) {
        const seleccion = this.internalSelected || [];

        const contieneTodas = seleccion.some((s) => s.id === 0);

        if (contieneTodas) {
          const soloIds = this.sucursales.map((s) => s.id);
          this.$emit("handle-click", soloIds);
        } else {
          const idsSeleccionadas = seleccion.map((s) => s.id);
          this.$emit("handle-click", idsSeleccionadas);
        }
      } else {
        this.$emit("handle-click", this.internalSelected?.id ?? null);
      }
    },
  },
  created() {
    this.fetch_sucursales();
  },
};
</script>
